// extracted by mini-css-extract-plugin
export default {"button":"FavoriteHeartButton-module__button__R8iyF"};